export const THREADS_REFRESH_INTERVAL_MS = 20 * 1000;
